export const WEATHER_FILTER = "weather"
export const PILOTS_FILTER = "pilots"
export const PILOT_FILTER = "pilot"
export const COPILOT_FILTER = "coPilot"
export const MEMBER_FILTER = "member"
export const TAGS_FILTER = "tags"
export const AXIS_FILTER = "axis"
export const ALL_FILTER = "all"
export const INPROGRESS_FILTER ="En cours"
export const FINISH_FILTER ="Terminés"
export const PROJECTS_FILTER = "project"
export const CRITICALITY_FILTER = "criticality"
export const ADVANCEMENT_FILTER = "advancement"
export const LAST_LAST_YEAR_FILTER = "lastLastYear"
export const LAST_YEAR_FILTER = "lastYear"
export const ACTUAL_YEAR_FILTER = "actualYear"
export const NEXT_YEAR_FILTER = "nextYear"
export const NEXT_NEXT_YEAR_FILTER = "nextNextYear"
export const STRATEGY_FILTER = "strategy"
export const UN_STRATEGY_FILTER = "unStrategic"
export const WEEK_FILTER = "week"
export const TWO_WEEKS_FILTER = "twoWeeks"
export const MONTH_FILTER = "month"
export const QUARTER_FILTER = "quarter"
export const SEMESTER_FILTER = "semester"
export const YEAR_FILTER = "year"
export const NEVER_UPDATED_FILTER = "neverUpdated"